import Resource from './Resource'

class GenderResource extends Resource {
    async index() {
        const response = await this.axios.get(`/common/genders`)
        return response.data
    }

    async initialize() {
        if (Object.keys(genderMap).length === 0) {
            const response = await this.index()
            genderMap = response.reduce((map, obj) => {
                map[obj.id] = obj
                return map
            },
            {})
            genderKeys = Object.keys(genderMap)
        }
    }
}

export default new GenderResource()
export let genderMap = {}
export let genderKeys = {}
